
export const en = {
    learn_more: 'Learn more',
    words: {
        'day': 'day',
        'days': 'days',
    },
    general: {
        cancel: 'Cancel',
    },
    calendar: {
        days: {
            sun: 'Sun',
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat'
        },
        months: {
            jan: 'January',
            feb: 'February',
            mar: 'March',
            apr: 'April',
            may: 'May',
            jun: 'June',
            jul: 'July',
            aug: 'August',
            sep: 'September',
            oct: 'October',
            nov: 'November',
            dec: 'December'
        },
        short_months: {
            jan: 'Jan',
            feb: 'Feb',
            mar: 'Mar',
            apr: 'Apr',
            may: 'May',
            jun: 'Jun',
            jul: 'Jul',
            aug: 'Aug',
            sep: 'Sep',
            oct: 'Oct',
            nov: 'Nov',
            dec: 'Dec'
        },
        today: 'Today',
        tomorrow: 'Tomorrow',
        yesterday: 'Yesterday',
        week: 'Week',
        month: 'Month',
        year: 'Year'
    },
    cities: {
        browse: 'Browse by destination',
        bologna: 'Bologna',
        firenze: 'Florence',
        cagliari: 'Cagliari',
        bari: 'Bari',
        milano: 'Milan',
        roma: 'Rome',
        palermo: 'Palermo',
        catania: 'Catania',
        links: {
            bologna: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-bologna/',
            firenze: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-florence/',
            cagliari: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-cagliari/',
            bari: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-bari/',
            milano: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-milan/',
            roma: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-rome/',
            palermo: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-palermo/',
            catania: 'https://scopri.auting.it/en/peer-to-peer-car-sharing-catania/',
        }
    },
    components: {
        search_bar: {
            cta: 'Search',
            select_date: 'Select date',
            select_dates: 'Select dates',
            time: 'Time',
            time_label: 'Time',
            select_start_datetime: 'Select start date and time',
            select_end_datetime: 'Select end date and time',
            booking_warning: 'Bookings must start at least 2 hours after current time',
            cancel: 'Cancel',
            confirm: 'Confirm',
            confirm_dates: 'Confirm Dates',
            start_date: 'Start date',
            end_date: 'End date',
            start_time_label: 'Start time',
            end_time_label: 'End time',
            end_before_start_error: 'End date cannot be before start date!',
            coordinates_error: 'Error retrieving coordinates. Try with another address.'
        },
        nav: {
            how_it_works: 'How it works',
            faq: 'FAQ',
            publish_your_car: 'Publish your car',
            sign_in: 'Sign in',
            get_started: 'Register',
            profile: 'Profile',
            earnings: 'Your earnings',
            cars: 'Your cars',
            trips_driver: 'Your trips',
            trips_owner: 'Your trips with your cars',
            documents: 'Documents',
            change_language: 'Change language',
            menu: 'Menu',
            open_menu: 'Open menu',
            logout: 'Logout',
            push_notifications: 'Push notifications',
            push_denied_hint: 'Notifications blocked: enable them in your browser settings.',
            push_error: 'Could not update notifications. Please try again.',
            push_open: 'Open',
        },
        footer: {
            branding_section: {
                claim: 'Convenient as your neighbour\'s car',
                description: 'Auting is the first Italian peer-to-peer car sharing platform. The service allows you to book a car from a private owner for one or more consecutive days. Travel anywhere in Italy, with the peace of mind of a strong insurance partner like Reale Mutua.',
            },
            links_section: {
                learn_more: 'Learn more',
                how_it_works: 'How it works',
                publish_your_car: 'Publish your car',
                faq: 'FAQ',
                blog: 'Blog',
                product: 'Product',
                download_ios: 'Download on iOS',
                download_android: 'Download on Android',
                legal: 'Legal',
                limitations: 'Limitations',
                privacy_policy: 'Privacy Policy',
                terms_of_service: 'Terms of Service',
                cookie_policy: 'Cookie Policy',
                copyright: '© Yago s.r.l. 2018 - all rights reserved - P. IVA 03488191200',
                support_email: 'support@auting.it',
                partner: 'Partner',
            }
        },
        faq: {
            title_first_line: 'Your questions,',
            title_second_line: 'our answers',
            cta: 'Read all FAQs',
            owner: {
                accordions: {
                    '1': {
                        question: 'How do I publish my car?',
                        answer: 'The process is very quick and can be done:\n\n\n - on the Auting website by clicking on the “publish your car” button on the home page;\n - through the Auting App, available in the Android and IOS stores, by clicking on the car icon in the App homepage.',
                    },
                    '2': {
                        question: 'How do car pick up and drop off work?',
                        answer: 'Pick-up of the car takes place only after the reservation has been paid. After the payment, the Owner\'s phone number will be visible in the trip details. The initial car pick-up and drop-off locations can be agreed upon by Driver and Owner during the booking process.',
                    },
                    '3': {
                        question: 'Who sets the price of my car?',
                        answer: 'You are free to set your desired minimum price for your car and update it at any time. You can also set a price for additional kilometers that can be purchased from the Driver during the reservation process.'
                    },
                    '4': {
                        question: 'Who pays for the refueling of the car?',
                        answer: 'We suggest delivering the car with a full tank of fuel. The Driver is responsible to return the car with the same fuel level that was present when the car was picked up and marked on the Checklist.',
                    },
                    '5': {
                        question: 'How many kilometres can the Driver cover?',
                        answer: 'For each day of booking, the Driver has 150 km available with a maximum of 500 km per week. At the time of booking, the Driver can purchase additional kms. The price of additional km is set by the Owner in the price section of the car profile.'
                    },
                },
            },
            driver: {
                accordions: {
                    '1': {
                        question: 'How do I book a car?',
                        answer: 'You can find a car either from the homepage of this website or on Auting’s app by typing in the city and dates that you\'re searching.\nYou will see available cars in the city and dates you choose on a map and in a list with price and car model.\nYou will be able to submit multiple booking requests at the same time.\nOwners will be able to accept your request, reject it or let it expire.\nOnce your request has been accepted, you can proceed with payment',
                    },
                    '2': {
                        question: 'Are there driver requirements for booking a car?',
                        answer: 'At the time of reservation request, the Driver must be at least 21 years old and have had a valid driving license in Italy for a minimum of 3 years.\nThe Driver must possess the following documents:\n\n - a valid identification document (ID card or passport)\n - a driving license valid in Italy (the date of first issue or last renewal of the license must be present on the document and must be dated before the last 3 years)\n - if the  license is issued in a nation outside the European Union, the Driver must present, in addition to the national license, an International Driving Permit (IDP)',
                    },
                    '3': {
                        question: 'Am I insured against all risks?',
                        answer: 'For the entire duration of the reservation, the car is covered by Reale Mutua Assicurazioni against damage, theft, broken glass, and vandalism, with premium 24/7 roadside assistance and a security deposit of 0 €.\n\nAt the time of booking, it is possible to choose the level of exposure to the risk of damage or theft and reach up to 0 € liability.\n\nThe base rate already includes a low liability limit.'
                    },
                    '4': {
                        question: 'How does car pick-up and drop-off work?',
                        answer: 'Car pick-up takes place only after the reservation has been paid.\nAfter payment, the Owner\'s phone number will be visible in the trip details.\nThe places of car pick-up and drop-off can be agreed upon between the Driver and the Owner during the booking process.',
                    },
                    '5': {
                        question: 'What is the difference between Auting and rental companies?',
                        answer: 'Auting is an eco-friendly service that allows the use of cars that would otherwise remain unused.\nThis makes it possible to provide a more user-friendly service, based on a direct connection with the Owner.\nFinally, the price of Auting is cheaper than a car rental service and includes:\n\n - premium 24/7 roadside assistance\n - a security deposit of 0 €\n - a limited liability threshold (to be selected at the time of booking).'
                    },
                },
            }
        },
        blog: {
            title: 'Auting Blog',
            cta: 'Read more'
        },
        owner: {
            top_subheadline: 'Do you have a car?',
            headline: 'Put it to work',
            cta: 'Publish your car',
            img_alt: 'Owner Illustration',
        },
        mobile_app: {
            subtitle: 'Use Auting on your phone',
            title: 'Start your journey',
            title_accent: 'in one tap 🎯',
        }
    },
    common: {
        back: 'Back',
        any: 'Any',
        reset: 'Reset',
        apply: 'Apply',
        retry: 'Retry',
        yes: 'Yes',
        no: 'No',
        per_day: 'day'
    },
    errors: {
        generic: 'An error occurred. Please try again later.',
        reservation: {
            Numero_telefono_mancante_o_non_verificato_prenotazione_veicolo_non_consentita: 'You cannot make a reservation because you have not yet verified your phone number. Go to your profile to verify your phone number.',
            Prenotazione_veicolo_non_consentita_Specificare_nome_e_cognome: 'You cannot make a reservation because your profile does not contain your full name. Go to your profile to add this information.',
            Data_inizio_prenotazione_mancante: 'To book a vehicle, you must specify a valid start date for the reservation.',
            Data_fine_prenotazione_mancante: 'To book a vehicle, you must specify a valid end date for the reservation.',
            Data_in_formato_non_corretto: 'The provided date is not in the correct format. Use the format YYYY-MM-DD HH:MM.',
            Id_del_veicolo_mancante: 'To book a vehicle, you must select a valid vehicle.',
            Messaggio_di_richiesta_prenotazione_mancante: 'To book a vehicle, you must provide a booking request message to the Owner.',
            Lunghezza_del_messaggio_superiore_al_limite_consentito: 'The length of the booking request message exceeds the allowed limit of 500 characters.',
            Data_di_inizio_noleggio_successiva_alla_data_di_fine_noleggio: 'The start date of the trip cannot be later than the end date.',
            La_data_di_inizio_noleggio_non_può_coincidere_con_la_data_di_fine_noleggio: 'The start date of the trip cannot be the same as the end date.',
            Periodo_della_prenotazione_superiore_al_massimo_consentito: 'The booking period exceeds the maximum allowed limit of 30 days.',
            Prenotazione_non_consentita_data_di_inizio_viaggio_troppo_ravvicinata: 'The booking is not allowed: the start date of the trip is too close. The booking must start at least 2 hours after the current time.',
            Veicolo_gia_prenotato_per_il_periodo_indicato: 'The vehicle is already booked for the specified period.',
            Prezzo_veicolo_non_ancora_impostato_prenotazione_veicolo_non_consentita: 'The vehicle cannot be booked because the price has not yet been set by the Owner.',
            Prezzo_veicolo_non_ancora_impostato_pubblicazione_veicolo_non_consentita: 'The vehicle cannot be published because the price has not yet been set by the Owner.',
            Prenotazione_non_consentita_lutente_che_richiede_la_prenotazione_è_il_proprietario_del_veicolo: 'You cannot book your own vehicle.',
            Veicolo_non_trovato: 'The selected vehicle does not exist.',
            Veicolo_di_annata_superiore_al_limite_consentito_non_prenotabile: 'The selected vehicle is older than the allowed limit and cannot be booked.',
            Prezzo_della_prenotazione_fuori_range: 'The booking price is out of the allowed range.'
        }
    },
    routes: {
        login: {
            title: 'Sign in into your account',
            subtitle: 'Please enter your credentials to continue.',
            else: 'else',
            dont_have_account: 'Don\'t have an account?',
            register: 'Register',
            enter_email: 'Enter your email',
            enter_password: 'Enter your password',
            forgot_password: 'Forgot password?',
            logging_in: 'Logging in',
            login: 'Login',
        },
        register: {
            title: 'Sign up for Auting',
            subtitle: 'Please fill in the form to create your account.',
            first_name: 'First name',
            your_first_name: 'Your first name',
            last_name: 'Last name',
            your_last_name: 'Your last name',
            else: 'else',
            do_have_an_account: 'Already have an account?',
            login: 'Login',
            register: 'Register',
            registering: 'Registering',
            enter_email: 'Enter your email',
            enter_password: 'Create a password',
            forgot_password: 'Forgot password?',
            success_message_in_dialog: 'Registration successful! Check your email to confirm your account, then log in.',
        },
        forgot_password: {
            title: 'Password Recovery',
            description: 'Reset your password to regain access to your account.',
            header_title: 'Forgot your password?',
            header_subtitle: 'Enter your email address and we\'ll send you a link to reset your password.',
            email_placeholder: 'your@email.com',
            send_reset_link: 'Send reset link',
            sending: 'Sending...',
            enter_email: 'Enter your email',
            invalid_email: 'Enter a valid email',
            reset_error: 'Error sending reset email. Please try again.',
            back_to_login: '← Back to login',
            email_sent: 'Email sent!',
            email_sent_message: 'We\'ve sent a password reset link to <strong>{email}</strong>, check your inbox and follow the instructions to reset your password.',
            go_to_login: 'Go to login',
        },
        home: {
            title: 'Auting - Peer-to-peer car sharing in Italy',
            description: 'Choose the perfect car for you, book it and drive. Thousands of private cars are waiting for you all over Italy. Forget car rental, forget car sharing, discover Auting\'s peer to peer car sharing!',
            keywords: 'car sharing, peer-to-peer car sharing, car rental, car hire, car mobility, ok mobility, Auting',
            header: {
                title: "Find, book, drive",
                description: "Book a car from a local in 150 served cities in Italy",
                project_insured_by: "Project insured by",
            },
            search: {
                placeholder: "Search for the perfect car",
                button: "Search",
            },
            steps_title: 'A car for holidays, for work, for moving... just follow these few steps:',
            steps: {
                '1': 'Find the perfect car for you',
                '2': 'Chat with the Owner',
                '3': 'Pay the reservation',
                '4': 'Pickup the car & drive',
            },
            pricing: {
                subtitle: 'What\'s better then a car rental service?',
                title_accent: 'Safe, Convenient, Comfortable.',
                description: 'Our Owners\' cars are easy to reach and offer you comfortable trips with the peace of mind.',
                cols: {
                    auting: {
                        description: 'The base prices already include PREMIUM options:',
                        items: {
                            '1': '✅ 0€ security deposit',
                            '2': '✅ Low liability in case of damage or theft',
                            '3': '✅ Premium 24/7 roadside assistance',
                            '4': '✅ Easy communication & pickup',
                        },
                        alt: {
                            sub_description: 'Additionally:',
                            sub_items: {
                                '1': '✅ With only €6/day you have 0€ liability in case of damage or theft*'
                            }
                        }
                    },
                    other: {
                        title: 'Other services',
                        description: 'Initial prices hide:',
                        items: {
                            '1': '❌ 1500 - 3500 € security deposit',
                            '2': '❌ High liability up to 3500 €',
                            '3': '❌ Basic assistance',
                            '4': '❌ Long queues at the counter',
                        },
                        alt: {
                            sub_separator: 'or:',
                            sub_description: '❌ up to 50€/day in addition to the base rental price for:',
                            sub_items: {
                                '1': '- 0€ liability in case of damage or theft',
                                '2': '- 0€ security deposit',
                                '3': '- premium insurance'
                            }
                        }
                    }
                }
            },
            auting_values: {
                title: 'and much more:',
                cols: {
                    '1': {
                        headline: 'A car within everyone\'s reach',
                        text: 'Cars located within the city, near train stations and airports. Or just around the corner!',
                    },
                    '2': {
                        headline: 'Not just a service, a real community',
                        text: '+65.000 active users among Owner and Driver',
                    }
                },
                cta: 'Discover more',
            },
            cities: {
                cta: 'Seach for a car in 150 cities',
            },
            cars_grid: {
                title: "Best cars in Milan",
                loading: 'Loading cars...',
                no_vehicles: 'No cars found for this search',
                error: 'Error loading: ',
            }
        },
        driver: {
            title: 'Auting: How does it work?',
            description: 'Find out how Auting\'s peer-to-peer car sharing works. Discover private owner’s cars around you, send a request and travel anywhere in Italy from 1 day up to 30 consecutive days.',
            header: {
                title: 'How does Auting work?',
            },
            how_it_works: {
                title: '',
                cols: {
                    '1': {
                        headline: 'Find the perfect car for you',
                        subheadline: 'Enter where and when you need a car, look at the offer and read reviews from previous users.',
                    },
                    '2': {
                        headline: 'Chat with the Owner',
                        subheadline: 'Send requests to Owners and chat directly with them to arrange car pick-up.',
                    },
                    '3': {
                        headline: 'Pay the reservation',
                        subheadline: 'Secure credit card payment via the platform.',
                    },
                    '4': {
                        headline: 'Pick-up the car & Drive!',
                        subheadline: 'On the day of the booking meet the owner for delivery or unlock the vehicle with the app.',
                    }
                }
            },
            advantages: {
                title: 'Why are Auting prices so convenient?',
                cols: {
                    '1': {
                        items: {
                            '1': 'Limited liability for damages or theft',
                            '2': 'Premium insurance cover',
                            '3': 'Premium roadside assistance 24/7',
                            '4': 'Free cancellation',
                            '5': '0€ security deposit',
                            '6': 'Easy communication for pick-up',
                            '7': 'AND MORE',
                            '8': 'With only €6/day you have 0€ liability in case of damage or theft*'
                        }
                    },
                    '2': {
                        title: 'Classic car rental services price:',
                        items: {
                            '1': 'Liability up to 3500€',
                            '2': 'No premium roadside assistance',
                            '3': '1500-3500 euro security deposit',
                            '4': 'Cancellation is not always included or may incur a financial penalty',
                            '5': 'Up to 50€/day in addition to the base rental price for:\n\n - 0€ liability for damage/theft\n\n - 0€ security deposit\n\n - premium insurance',
                            '6': 'Long waiting times at the counter',
                        }
                    },
                }
            },
            service: {
                title: 'Just a smart, convenient, service',
                cols: {
                    '1': {
                        headline: 'A proximity service',
                        subheadline: 'Cars are located around you. Geolocalise and reach the nearest car to leave for your destination.',
                    },
                    '2': {
                        '1': {
                            headline: 'Fast check-in!',
                            subheadline: 'Forget queuing at the car rental counter to collect your car. Pick up your car in just 5 minutes!',
                        },
                        '2': {
                            headline: 'Extensive service',
                            subheadline: 'Auting cars are all over Italy, in the streets of city centres, near stations or airports.',
                        },
                    }
                }
            }
        },
        owner: {
            title: 'Auting: share your car',
            description: 'Become an Auting Owner and earn money by sharing your car. Register your car for free in a few easy steps. Share it when you want, at the price you choose.',
            earn: {
                title: 'Your car could make {currency} {earnings}',
                slider: '{days} {unit}',
                estimated_earnings: 'Your gain estimate for {days} days of sharing per month',
                loading: 'Loading your potential earnings...',
                loading_car_data: 'Getting latest car data...',
                loading_error: 'Error loading data',
                cta: 'Publish your car',
                img_alt: 'Car Illustration',
                select_car_type: 'Select car type',
                select_car_year: 'Select car year'
            },
            metrics: {
                title: 'Join thousands of owners on Auting.',
                title_accent: 'It\'s easy',
                cols: {
                    '1': {
                        headline: '+8.000',
                        subheadline: 'registered cars',
                    },
                    '2': {
                        headline: '+65.000',
                        subheadline: 'users',
                    },
                    '3': {
                        headline: '24/7',
                        subheadline: 'Premium assistance',
                    },
                    '4': {
                        headline: 'Covered by',
                        subheadline: '',
                        image: true,
                    }
                }
            },
            how_to_publish: {
                title: 'Publish your car.<br/>Share. Earn.',
                title_accent: 'Sounds easy? It is.',
                cols: {
                    '1': {
                        headline: 'Sign-up',
                        subheadline: 'Create your account and publish your car.',
                    },
                    '2': {
                        headline: 'Publish',
                        subheadline: 'Upload photos and a description of the car. Specify its price and the availability',
                    },
                    '3': {
                        headline: 'Share',
                        subheadline: 'Receive requests, accept or reject them. Reach out to the driver directly!',
                    },
                    '4': {
                        headline: 'Earn',
                        subheadline: 'Receive earnings directly into your account at the end of the trip',
                    }
                }
            },
            advantages: {
                title: 'Why is Auting',
                title_accent: 'so unique?',
                cols: {
                    '1': {
                        headline: 'Auting is proven and secure service',
                        subheadline: 'Supported by trusted partners such as Cassa Depositi Prestiti and Reale Mutua Assicurazioni.',
                    },
                    '2': {
                        headline: 'Protecting your car is everything to us',
                        subheadline: 'Insurance and 24/7 premium roadside assistance is always included in the service.',
                    },
                    '3': {
                        headline: 'We support you in sharing',
                        subheadline: 'Customer service, brokerage with drivers and user verification are included in the service.',
                    },
                    '4': {
                        headline: 'We contribute to your success',
                        subheadline: 'Our website and app work to make your car more visibile, to your neighbour as well as to Italian or foreign travellers.',
                    },
                    '5': {
                        headline: 'Easy and secure transactions',
                        subheadline: 'We collect the money from the Driver before the trip. At the end of the journey you receive from us a back transfer directly to your account.',
                    }
                }
            },
            ways_of_sharing: {
                title_first_line: '2 ways',
                title_second_line: 'of sharing',
                cols: {
                    '1': {
                        headline: 'Meeting with the Owner',
                        subheadline: 'Meet the owner at the decided location. Fill in the checklist and photograph the state of the car. Exchange keys.',
                    },
                    '2': {
                        headline: 'Auting Connect',
                        subheadline: 'Available only in the city of Milan. With the Auting Connect device you can share the car remotely via the App',
                        label_accent: 'Earn more!',
                    },
                },
            },
            protections: {
                top_subheadline_accent: '“Is it secure? It\'s about my car!”',
                title: 'Protecting your car is our first priority',
                cta: 'Learn more',
                insured_by: 'Project insured by',
                cols: {
                    1: {
                        top_subheadline_accent: 'No worries',
                        headline: 'You are protected ✅',
                    },
                    2: {
                        headline: '24/7 Premium roadside assistance',
                        subheadline: 'Towing service for the vehicle to the closest or chosen workshop.',
                    },
                }
            },
            super_owner: {
                title: 'The more you share, the more you earn',
                text: 'Discover the SuperOwner programme.',
                cta: 'Learn more',
            },
            rent_pros: {
                top_title: {
                    0: 'Renting for Professionals',
                },
                title: {
                    0: '',
                }
            },
        },
        car: {
            instant_booking: 'Instant acceptance',
            instant_booking_hint: 'This vehicle accepts requests automatically: you get confirmation right away.',
            page_title: 'Car rental',
            car: 'Car',
            owner: 'Owner',
            new: 'New',
            not_specified: 'Not specified',
            location_not_available: 'Location not available',
            discount_example: '3 day discount, 7€',
            free_cancellation_until: 'Free cancellation until',
            hours_before: 'hours before',
            free_cancellation_24h: 'Free cancellation until 24h before',
            km_included: 'km included',
            rca_base_included: 'RCA Base included',
            not_included: 'Not included',
            to_be_chosen: 'To be chosen',
            vehicle_not_available: 'Vehicle not available for selected dates',
            please_select_dates: 'Please select booking dates',
            vehicle_info_missing: 'Vehicle information is missing',
            seats: 'seats',
            doors: 'doors',
            trips: 'trips',
            insurance: 'Insurance',
            comforts: 'Comforts',
            no_comforts_listed: 'No specific comforts listed',
            conditions: 'Booking conditions',
            vehicle_details: 'Vehicle details',
            keyless: 'Keyless',
            verified: 'Verified',
            mileage: 'Mileage',
            loading_owner_info: 'Loading owner info...',
            failed_load_owner_info: 'Failed to load owner info',
            trips_as_owner: 'trips as owner',
            super_owner: 'Super Owner',
            pro: 'Pro',
            new_vehicle: 'New Vehicle',
            about_vehicle: 'About this vehicle',
            about_vehicle_description: '',
            how_does_it_work: 'How does it work?',
            auting_connect_modal: {
                title: 'How Auting Connect works',
                content: 'With Auting Connect you will open and close the car only by Auting App.\nBefore sending the reservation request, it is mandatory for the Driver to verify the availability of the App in their country.\nThe checkin and checkout of the reservation will be made only by Auting App.The car position will be visible 30 minutes before the beginning of the booking. (Note: you will not be able to start your trip until the exact departure time of your booking). Make sure GPS and mobile data are activated in your smartphone.You will receive the PIN necessary to open the car via email - header \'PIN required to access the car\'.\nWhen you will be next to the car, you will follow the check-in procedure in the App. You will find the keys inside glove box in the car.\nDuring the trip, you will use the car keys to open and close the car.\nAt the end of the trip, you must return the car within 500 meters from the check-in point and complete the check-out procedure in the App.',
                faq_link: 'FAQ',
                how_it_works_link: 'How it works',
                close: 'CLOSE'
            },
            pro_user_modal: {
                title: 'Professional User',
                content: '<strong>A user Owner is defined "Professional" if the trip is covered by his insurance partners</strong>, included in the price paid online. This coverage is for third party liability and may have other insurance coverages included in the price (i.e. Collision Damage Waiver, Theft, assistance, other). <strong>Auting does not cover the trip with our insurance partner Reale Mutua</strong>.<br><br>If the Owner is Professional, auting\'s terms and conditions are valid till the date of the check-in (excluded). Professionals have their own terms and condition for check-in, for the trip, for the check-out and for the after-trip management.<br><br><strong>At the check-in, Professional Owner may ask you to sign his terms and conditions and to agree with further requirements. For instance, he may: ask for a deposit on your credit card; </strong>offer additional insurance coverage and extra services; ask you an extracost if you desire the car delivery in a specific location; manage fines in a different way than auting\'s way; provide a different car but of similar economic value.<br><br>When booking and paying online for this car, the Driver understands and accepts that the Professional Owner may ask you to sign his terms and conditions at check-in and/or check-out',
                close: 'CLOSE'
            },
            year: 'Year',
            brand: 'Brand',
            model: 'Model',
            type: 'Type',
            fuel: 'Fuel',
            gears: 'Transmission',
            doors_number: 'No. doors',
            unknown: 'Unknown',
            reviews: 'reviews',
            trips_completed: 'trips completed',
            vehicle_new_no_reviews: 'This vehicle is new and has no reviews yet.',
            be_first_to_review: 'Be the first to review this car!',
            system_review: 'System review',
            no_comment_provided: 'No comment provided',
            guidelines: 'Guidelines',
            faqs: 'FAQs',
            read_more: 'Read more',
            dates: 'Dates',
            change: 'Change',
            pickup_return: 'Pickup and return',
            trip_saving: 'Trip saving',
            cancellation: 'Cancellation',
            distance_included: 'Distance included',
            request_more: 'Request more',
            checking_availability: 'Checking availability...',
            continue_booking: 'Continue with booking',
            no_charge_note: 'You will not be charged at this stage',
            vehicle_not_available_short: 'Vehicle not available',
            vehicle_not_available_dates: 'This vehicle is not available for the selected dates.',
            days: 'days',
            discount: 'discount',
            additional_km: 'Additional km',
            service_cost: 'Service cost',
            security_deposit: 'Security deposit',
            limited_liability: 'Limited liability',
            enter_promo_code: 'Enter promo code',
            apply: 'Apply',
            coupon: 'Coupon',
            total: 'Total',
            loading_car_details: 'Loading car details...',
            edit_booking_dates: 'Edit booking dates',
            select_additional_km: 'Select additional kilometers',
            continue: 'Continue',
            not_available: 'Not available',
            booking_summary: 'Booking summary',
            transmission: {
                manual: 'Manual',
                automatic: 'Automatic'
            },
            modify_booking_dates: 'Modify booking dates',
            select_additional_kilometers: 'Select additional kilometers',
            km_description: 'Choose how many additional kilometers you need for your trip:',
            //             no_charge_at_this_stage: 'Non riceverai alcun addebito in questa fase. Il pagamento sarà elaborato dopo l\'approvazione del proprietario.',

            no_charge_at_this_stage: 'You will not be charged at this stage. Payment will be processed after the owner\'s approval.',
            be_first_reviewer: 'Be the first to review this car!',
            fuel_types: {
                benzina: 'Gasoline',
                diesel: 'Diesel',
                gpl: 'GPL',
                metano: 'Methane',
                elettrica: 'Electric',
                ibrida: 'Hybrid'
            },
            categories: {
                berlina: 'Saloon',
                city_car: 'City Car',
                fuoristrada: 'Off-road',
                minivan: 'Minivan',
                station_wagon: 'Station Wagon',
                suv: 'SUV',
                crossover: 'Crossover',
                furgone: 'Van',
            },
            comforts_list: {
                animali: 'Pets allowed',
                aria_condizionata: 'Air conditioning',
                catene_da_neve: 'Snow chains',
                fumatori: 'Smokers',
                guida_disabili: 'Disabled driving',
                lettore_cd: 'CD player',
                navigatore: 'Navigator',
                permesso_ztl: 'ZTL permit',
                pneumatici_invernali: 'Winter tires',
                porta_bici: 'Bike rack',
                porta_pacchi: 'Roof rack',
                porta_sci: 'Ski rack',
                porta_usb: 'USB port',
                seggiolino_bambini: 'Child seat',
                sensori_parcheggio: 'Parking sensors',
                luci_xeno: 'Xenon lights',
                cruise_control: 'Cruise Control',
                guida_disabili: 'Disabled driving',
            },
            conditions_list: {
                animali: 'Animals NOT allowed',
                fumatori: 'No smoking',
            },
            promo_box: {
                title: 'SPECIAL PROMOTION',
                description: 'ZERO LIABILITY PROMO for only +6€/day!\nClick continue to choose how to protect your trip.'
            },
            protection_by_pro_owner: 'Insurance provided by Professional Owner',
            invalid_promo_code: 'Invalid promo code',
            connect_claim: 'Open this car via app. No person interaction required.',
        },
        search: {
            page_title: 'Search for the car you need',
            cars_available: 'cars available',
            cars_found: 'cars found',
            searching_vehicles: 'Searching vehicles...',
            search_error: 'Search error',
            loading_error: 'Error loading vehicles',
            no_vehicles_found: 'No vehicles found for the selected search criteria. Try changing the dates or filters, or expanding your search to nearby locations.',
            refresh_search: 'Refresh search',
            sort_by: 'Sort by',
            verified: 'Verified',
            trips: 'trips',
            per_day: 'day',
            total: 'total',
            why_convenient: 'Why is it convenient?',
            no_reviews: 'No reviews',
            new_vehicle: 'New vehicle',
            update_search: 'Update your search',
            seats: 'seats',
            included: 'included',
            locate_on_map: 'Show on map',
            sorting: {
                relevance: 'Relevance',
                price: 'Price',
                distance: 'Distance'
            },
            transmission: {
                manual: 'Manual',
                automatic: 'Automatic'
            },
            filters: {
                title: 'Filters',
                type: 'Type',
                price_range: 'Price Range',
                auting_connect: 'Auting Connect',
                super_owner: 'Super Owner',
                super_owner_only: 'Only Super Owners',
                super_owner_desc: 'Super Owners are professional owner experts in...',
                all_owners: 'All Owners',
                filter_by_car: 'Filter by car',
                any_brand: 'Any Brand',
                seats: 'Seats',
                doors: 'Doors',
                fuel: 'Fuel',
                gear: 'Gear',
                categories: {
                    saloon: 'Saloon',
                    city_car: 'City Car',
                    off_road: 'Off-road',
                    minivan: 'Minivan',
                    station_wagon: 'Station Wagon',
                    suv: 'SUV'
                },
                connect: {
                    any_desc: 'Both with and without Auting Connect.',
                    with: 'With Auting Connect',
                    with_desc: 'Open doors via the app. No in-person interaction needed.',
                    without: 'Without Auting Connect',
                    without_desc: 'In-person interaction needed when starting/ending the trip.'
                },
                fuel_types: {
                    gasoline: 'Gasoline',
                    diesel: 'Diesel',
                    lpg: 'LPG',
                    methane: 'Methane',
                    electric: 'Electric',
                    hybrid: 'Hybrid'
                },
                gear_types: {
                    manual: 'Manual',
                    automatic: 'Automatic'
                }
            },
            price_info: {
                title: 'Why is it convenient?',
                premium_includes: 'The PREMIUM price includes:',
                remember: 'Remember',
                competitor_comparison: 'when evaluating the price, consider that our competitors require a security deposit and liability options up to €3500.',
                benefits: {
                    free_cancellation: 'Free cancellation',
                    reduced_liability: 'Reduced liability for damage and theft',
                    roadside_assistance: '24/7 roadside assistance',
                    no_deposit: '0€ security deposit'
                }
            },
            premium_box: {
                title: 'The PREMIUM price includes:',
                benefits: {
                    free_cancellation: 'Free cancellation',
                    reduced_liability: 'ZERO LIABILITY PROMO for theft and damage for only +6€/day!',
                    roadside_assistance: '24/7 roadside assistance',
                    no_deposit: 'No security deposit'
                }
            }
        },
        alternatives: {
            page_title: 'These Owners respond quickly',
            page_subtitle: 'Choose from Owners with the highest response rates — who almost always say yes. Don\'t wait: other drivers may book them before you.',
            banner_title: '{n} cars selected for you',
            banner_subtitle: 'We have selected these cars after reviewing your booking requests.\r\nWe hope one of them is perfect for you!\r\nNew cars are added every day, so check back if you don\'t find the right one immediately.',
            see_all_results: 'Search for more cars',
        },
        protection: {
            page_title: 'Trip protection',
            auting_protection: 'Only with Auting',
            title: 'Take full advantage, choose theft/damage coverage...',
            features: {
                title: 'Already included in ALL options:',
                assistance: {
                    title: 'Assistance',
                    desc: '24/7 roadside assistance'
                },
                liability: {
                    title: 'Liability options',
                    desc: 'Protected for physical damage, collision, theft, vandalism, glass protection'
                },
                deposit: {
                    title: 'Security deposit',
                    desc: 'No security deposit'
                }
            },
            details_prefix: 'For liability limitation options details,',
            learn_more: 'learn more',
            choose_protection: 'Choose the protection theft and damage',
            promo: 'Promo',
            max_out_of_pocket: 'in case of damage or theft',
            no_out_of_pocket: 'No out-of-pocket expenses in case of damage or theft',
            physical_damage: 'Physical damage, collision, theft, vandalism, glass protection',
            no_deposit: 'No security deposit',
            free: 'Free',
            summary_title: 'You will be able to proceed with the payment after the owner has accepted the booking',
            days: 'days',
            from: 'From',
            to: 'To',
            additional_km: 'Additional km',
            service_cost: 'Service cost',
            security_deposit: 'Security deposit',
            enter_promo_code: 'Enter promo code',
            apply: 'Apply',
            protection: 'Protection',
            coupon: 'Coupon',
            total: 'Total',
            pricing_error: 'Error updating pricing',
            next: 'Next →',
            booking_summary: 'Booking summary'
        },
        booking_summary: {
            page_title: 'Booking summary',
            title: 'Booking Summary',
            subtitle: 'Review your booking details before confirming',
            trip_info: 'Trip Info',
            dates: 'Dates',
            pickup_return: 'Pickup & Return',
            trip_saving: 'Trip Saving',
            cancellation: 'Cancellation',
            distance_included: 'Distance included',
            protection: 'Protection',
            change: 'Change',
            request_more: 'Request more',
            confirm_booking: 'Confirm',
            free_cancellation: 'Free cancellation until 24h before',
            trip_discount: '3-day discount',
            total: 'Total',
            days: 'days',
            not_specified: 'Not specified',
            location_not_available: 'Location not available',
            km_included: 'km included',
            additional: 'additional',
            booking_summary: 'Booking summary',
            additional_km: 'Additional km',
            service_cost: 'Service cost',
            security_deposit: 'Security deposit',
            enter_promo_code: 'Enter promo code',
            applied: 'Applied',
            apply: 'Apply',
            promo: 'Promo',
            booking_note: 'You will not be charged at this stage. Payment will be processed after owner approval.',
            edit_dates: 'Edit booking dates',
            message_to_owner: 'Message to Owner',
            your_message: 'Your message to the owner',
            message_placeholder: 'Write a message to the owner...',
            cancel: 'Cancel',
            sending: 'Sending...',
            send_request: 'Send Request',
            select_additional_km: 'Select Additional Kilometers',
            default_message: 'Hi! I\'m interested in booking your {vehicleName} from {startDate} to {endDate}. Looking forward to hearing from you!',
            auth_required: 'You must be authenticated to complete the reservation. Do you want to sign in now?',
            message_required: 'Please write a message to the owner',
            data_restored: 'Your booking data has been restored. You can continue with your reservation.',
            authentication_required: 'You must be authenticated to complete the reservation. Do you want to sign in now?',
            login_now: 'Login',
            phone_not_verified_error: 'You cannot make a reservation because you have not verified your phone number yet. Go to your profile to verify your phone number.'
        },
        booking_confirmation: {
            page_title: 'Request sent to the owner',
            title: 'Request sent to the owner',
            instruction_1: '1. Owner usually reply in few hours.',
            instruction_2: '2. After the Owner will approve the request, you\'ll be able to proceed with the payment.',
            trip_info: 'Trip Info',
            vehicle_name: 'Vehicle Name',
            location_not_available: 'Location not available',
            dates: 'Dates',
            not_specified: 'Not specified',
            pickup_return: 'Pickup & Return',
            trip_saving: 'Trip Saving',
            day_booking: 'day booking',
            cancellation: 'Cancellation',
            free_cancellation_until: 'Free cancellation until 24h before departure',
            distance_included: 'Distance included',
            km_included: 'km included',
            additional: 'additional',
            protection: 'Protection',
            homepage: 'Homepage',
            invalid_date: 'Invalid date',
            accepted_title: 'Booking accepted!',
            accepted_instruction: 'Your booking has been automatically accepted. You can now proceed with the payment.',
            owner_message_label: 'Message from the owner',
            proceed_to_payment: 'Proceed to payment',
            suggestions: {
                title: 'Similar cars available for the same dates',
                subtitle: 'We have selected these cars <strong>especially for you</strong>, available for the same dates. They belong to owners who respond quickly.<br/><br/>We recommend that you send a request, then decide whether to finalize it or not, as other drivers may book them before you.',
                see_all: 'Or you can make a new search',
            },
            protection: {
                label: 'Protection',
                minimum_750: 'Minimum 750',
                standard_500: 'Standard 500',
                smart_250: 'Smart 250',
                franchigia_0: 'Peace of mind 0',
            }
        }
    },
}